module.exports = __webpack_public_path__ + "img/mac-screen-medium.895b89b7.png";